import date from 'date-and-time';

export default function FormattedDate(rawPostDate) {
  if (rawPostDate === undefined || rawPostDate === null) {
    return;
  }
  const postDate = date.parse(rawPostDate, 'YYYY-MM-DD');
  return date.format(postDate, 'MMMM D, YYYY');
}
